var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai-support-box"},[_c('img',{attrs:{"src":require("@/assets/images/funding/icon-ai_supporter.svg"),"alt":"ai 아이콘"}}),_c('p',{staticClass:"ml-3 mb-0",domProps:{"innerHTML":_vm._s(_vm.xaiMsg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }